import React, {
  useEffect, useState,
} from 'react';
import {
  GoogleMap, useLoadScript, MarkerF, InfoWindowF,
} from '@react-google-maps/api';
import PropTypes from 'prop-types';

const containerStyle = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  right: '0px',
  bottom: '0px',
};

// Custom hook for geocoding
const useGeocode = () => {
  const geocodeAddress = (address) => new Promise((resolve, reject) => {
    const { google } = window;
    if (!google || !google.maps) {
      reject(new Error('Google Maps API is not loaded.'));
      return;
    }
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        const latLng = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };
        resolve(latLng);
      } else {
        reject(new Error(`Geocoding failed: ${status}`));
      }
    });
  });

  return { geocodeAddress };
};

const Maps = ({ mapClientId, formSubmissionPayload }) => {
  const [mapLocation, setMapLocation] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsClientId: mapClientId,
  });
  const { geocodeAddress } = useGeocode();

  useEffect(() => {
    const fetchLocation = async () => {
      if (formSubmissionPayload.fetchedLocation) {
        setMapLocation(formSubmissionPayload.fetchedLocation);
      } else if (formSubmissionPayload.fullAddress) {
        /*
        const city = "Edmonton";
        const state = "Alberts";
        const postal = "T6W 0L9";
        const Street = "5260 Windermere Blvd";
        const businessName = "California Pizza Kitchen";
        const phone = "+1 780-250-6601"; //"(780) 250-6601"
        const url = "https://cpk.ca/"; */
        try {
          const location = await geocodeAddress(formSubmissionPayload.fullAddress);
          setMapLocation(location);
        } catch (error) {
          console.error('Error fetching geocoded location:', error);
        }
      }
    };
    fetchLocation();
  }, []);

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading map...</div>;
  }

  return (
    <div>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapLocation || { lat: 0, lng: 0 }} // Default center if no location is set
        zoom={15}
      // onLoad={onMapLoad}
      >
        {mapLocation && (
          <MarkerF
            title={formSubmissionPayload.formattedAddress}
            position={mapLocation}
            onClick={() => setShowInfo(true)}
          />
        )}
        {showInfo && mapLocation && (
          <InfoWindowF
            position={mapLocation}
            onCloseClick={() => setShowInfo(false)}
          >
            <div>
              <h4>{formSubmissionPayload.businessName}</h4>
              <p>{formSubmissionPayload.formattedAddress}</p>
            </div>
          </InfoWindowF>
        )}
      </GoogleMap>
    </div>
  );
};

Maps.propTypes = {
  mapClientId: PropTypes.string.isRequired,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default Maps;
